import React, { Component, Fragment } from "react";
import { Avatar, Col, Divider, List, Modal, Row, Table, Tooltip } from "antd";
import moment from "moment-jalaali";
import { PriceFormat } from "../scripts/helpers";
import { Constants } from "../scripts/settings";
import Resources from "../scripts/resources";
import API from "../scripts/api";

class CirculationBarcodesView extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      filter: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      selected: {},
      barcodes: [],
      loading: false
    };
  }
  
  handleDidMount = async(data = {}) => {
    this.setState({barcodes: []})
     await this.brarcodesListBySelectedGroup(data)

  }

  handleWillUnmount = () => {

  }
  brarcodesListBySelectedGroup = (data) => {
    this.setState({loading: true})
    return API.circular_goods.brarcodesListBySelectedGroup(data)
      .then((result) => {
        this.setState({loading: false})
        this.setState({data: result.data})
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

    render() {
    const {  onCancel, visible } = this.props;
    const {barcodes, data, loading} = this.state;
 
    
    const columns = [
      {
        title: '#',
        key: 'index',
        // width: "20px",
        render: (text: string, record: any, index: number) => index + 1 ,
      },  
      {
        title: Resources.barcode,
        dataIndex: "barcode",
        className: "col-center",
        // width: "150px",
      },
      {
        title: Resources.customer,
        dataIndex: "cart",
        className: "col-center",
        render: (val) =>
          val?.user ? (val?.user?.name ? `${val.user?.name} ${val.user?.family}` : val.user?.family) : "-",
         
      },
      {
        title: Resources.type,
        dataIndex: "is_scan",
        className: "col-center",
        // width: "150px",
          render: (val) =>
          val == "1" ? <span style={{color: "green"}}>{Resources.scanned}</span> : <span style={{color: "red"}}>{Resources.deleted}</span>,
         
      },
     
    ];

  

    return (
      <Modal
        title={Resources.view}
        visible={visible}
        onCancel={onCancel}
        footer={false}
        width={1000}
      >
        <Table
         loading={loading}
          columns={columns}
          dataSource={data ?? []}
          pagination={false}
          size="small"
          rowKey="id"
          scroll={{ x: 952 }}
          
        />
       
       
      </Modal>
    );
  }
}

export default CirculationBarcodesView;
